import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuard, ConditionType, FormType, ModalSize, RefreshType, RequestType } from "yt-ng-framework";
import { LookupsRoutes } from "../lookups/routes";
import { EfaktureComponent } from "./efakture.component";
import { HomeComponent } from "./home/home.component";
import { ProveraPosiljaoca } from "./ulazni-dokument-dobavljaca/provera-posiljaoca/provera-posiljaoca";
import { ProveraPosiljaocaComponentComponent } from "./ulazni-dokument-dobavljaca/provera-posiljaoca/provera-posiljaoca-component.component";
import { UlazniDokumentDobavljaca } from "./ulazni-dokument-dobavljaca/ulazni-dokument-dobavljaca";
import { UlazniDokumentDobavljacaTabsComponent } from "./ulazni-dokument-dobavljaca/ulazni-dokument-dobavljaca-tabs.component";
import { UlazniDokumentDobavljacaView } from "./ulazni-dokument-dobavljaca/ulazni-dokument-dobavljaca-view";
import { SefAccessGuard } from "./guards/sef-access.guard";

let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'ulazniracuni',
        component: UlazniDokumentDobavljacaTabsComponent,
        pathMatch: 'full',
        canActivate: [SefAccessGuard],
        // canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                label: 'TABLE.ULAZNIRACUNI.PLURAL',
                // defaultListConfig: {
                //     showToolbar: false,
                //     showAddButton: false,
                //     showDeleteAllButton: false,
                //     showPrintButton: true
                // },   
                userRightsModelName: 'ulazni-racun',
                modelName: 'UlazniDokumentDobavljaca',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/efakture/UlazniRacuni' }],
                modelClass: UlazniDokumentDobavljaca,
                shortModelClass: UlazniDokumentDobavljacaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'ULAZNIDOKUMENTDOBAVLJACA.BRDOK.SINGULAR', visible: true, canHide: false, width: '15%' }
                    , { name: 'Datum', label: 'ULAZNIDOKUMENTDOBAVLJACA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: true, width: '10%' }
                    , { name: 'Komitent', label: 'ULAZNIDOKUMENTDOBAVLJACA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '30%' }
                    , { name: 'BrojUlaznogDokumentaDobavljaca', label: 'ULAZNIDOKUMENTDOBAVLJACA.BROJULAZNOGDOKUMENTADOBAVLJACA.SINGULAR', visible: true, canHide: false, width: '15%' }
                    , { name: 'Ukupno', label: 'ULAZNIDOKUMENTDOBAVLJACA.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '15%' }
                    , { name: 'ProvajderID', label: 'Provaj.', type: 'number', visible: false, width: '0%', canHide: false }
                    , {
                        name: 'StatusColor'
                        , label: 'ULAZNIDOKUMENTDOBAVLJACA.STATUSGENERICNAME.SINGULAR'
                        , type: "color-box"
                        , visible: true
                        , candHide: false
                        , width: '10%'
                        , aligment: 'center' 
                        , tooltipName: 'StatusTooltip'
                        , tooltipName2: 'Komentar'
                    }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}
                    ,{ name: 'Trosak', label: 'ULAZNIDOKUMENTDOBAVLJACA.TROSAK.SINGULAR', type: 'boolean', visible: true, width: '5%', canHide: false }

                    // , { name: 'UlaziUSumu', label: 'UlaziUSumu', type: 'bool', visible: false, width: '3%', canHide: true }

                ],
                tableColumnsSums: [
                    {
                        columns: 'Ukupno'
                        , condition: {
                            columnName: 'UlaziUSumu'
                            , conditionType: ConditionType.Equals
                            , value: true
                        }
                    }
                ],  
                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'ULAZNIDOKUMENTDOBAVLJACA.OSVEZISTATUS.ACTION' }
                    , { Name: 'Item 2', Action: 'AcceptDocument', Label: 'ULAZNIDOKUMENTDOBAVLJACA.ACCEPTDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityForAccept }
                    , { Name: 'Item 3', Action: 'RejectDocument', Label: 'ULAZNIDOKUMENTDOBAVLJACA.REJECTDOCUMENT.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityForReject }
                    , { Name: 'Item 4', Action: 'IzmeniKomitenta', Label: 'ULAZNIDOKUMENTDOBAVLJACA.IZMENIKOMITENTA.ACTION' }
                    , { Name: 'Item 5', Action: 'PrebaciUTroskove', Label: 'ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityForPrebaciUTrosak }

            ],
            tableContextMenu: [
              { Name: 'Item 1', Action: 'PrebaciUTroskove', Label: 'ULAZNIDOKUMENTDOBAVLJACA.PREBACIUTROSKOVE.ACTION' }

            ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                formControlDataName: 'efakture/ulazniracuni',
                requestType: RequestType.POST,
            },
            mainTitle: 'ulazni dokument',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'ULAZNIDOKUMENTDOBAVLJACA.PLURAL'
        }
        
    }
    , {
        path: 'provera-posiljaoca',
        component: ProveraPosiljaocaComponentComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                modelClass: ProveraPosiljaoca,
                parentProperty: '',
                tableColumns: [
                    { name: 'BrojDokumenta', label: 'PROVERAPOSILJAOCA.BROJ', visible: true, canHide: false, width: '10%' },
                    { name: 'DatumDokumenta', label: 'PROVERAPOSILJAOCA.DATUM', visible: true, canHide: false, type: 'ngbDate', format: 'dd.MM.yyyy', width: '8%' },
                    { name: 'NazivPosiljaoca', label: 'PROVERAPOSILJAOCA.NAZIV', visible: true, canHide: false, width: '25%' },
                    { name: 'PibPosiljaoca', label: 'PROVERAPOSILJAOCA.PIB', visible: true, canHide: false, width: '10%' },
                    { name: 'MaticniBrojPosiljaoca', label: 'PROVERAPOSILJAOCA.MATICNIBROJ', visible: true, canHide: true, width: '10%' },
                    { name: 'UlicaPosiljaoca', label: 'PROVERAPOSILJAOCA.ULICA', visible: true, canHide: true, width: '20%' },
                    { name: 'GradPosiljaoca', label: 'PROVERAPOSILJAOCA.GRAD', visible: true, canHide: true, width: '15%' },
                    { name: 'PostojiUBazi', label: 'PROVERAPOSILJAOCA.POSTOJIUBAZI', visible: true, canHide: false, width:'2%' }
                    
                ],
                tableRowColors: [],
                sortBy: 'NazivPosiljaoca',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'NazivPosiljaoca'                
            },
            mainTitle: 'PROVERA POŠILJAOCA',
            modalSize: ModalSize.Xl,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'PROVERAPOSILJAOCA.PLURAL',
            updateComponent: ProveraPosiljaocaComponentComponent
        }
    }
]

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: EfaktureComponent,
        children: childrenRoutes
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class EfaktureRoutingModule{}

export function CheckContextMenuAvailabilityForAccept(item: UlazniDokumentDobavljacaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "sent" || item.StatusGenericName == "seen" || item.StatusGenericName == "rejected" || item.StatusGenericName =="renotified");
}

export function CheckContextMenuAvailabilityForReject(item: UlazniDokumentDobavljacaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "sent" || item.StatusGenericName == "seen" || item.StatusGenericName =="renotified");
}

export function CheckContextMenuAvailabilityForPrebaciUTrosak(item: UlazniDokumentDobavljacaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && item.StatusGenericName == "approved" && !item.Trosak;
}
